import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DependenciesModule } from '../dependencies.module';

import { FreshAppRoutingModule } from './fresh-app-routing.module';
import { ViewDisbursedComponent } from './view-disbursed/view-disbursed.component';
import { ViewNtbComponent } from './view-ntb/view-ntb.component';
import { ViewIncompleteJourneyComponent } from './view-incomplete-journey/view-incomplete-journey.component';
import { ViewFailurePageComponent } from './view-failure-page/view-failure-page.component';
import { ViewreviewJourneyComponent } from './view-review-journey/view-review-journey.component';

import { FreshAppComponent } from './fresh-app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
// import { CoreModule } from './core/core.module';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewSummaryComponent } from './view-summary/view-summary.component';
import { ViewEtbComponent } from './view-etb/view-etb.component';
import { OpenDialogYesOrNo } from './dialog-yes-or-no/dialog-yes-or-no.component';
import { AdminModule } from 'app/admin/admin.module';
import { AdminService } from 'app/admin/admin.service';
import { ReconciliationReportsComponent } from '../fresh-app/reconciliation-reports/reconciliation-reports.component';
import { ErrorLogComponent } from '../fresh-app/error-log/error-log.component';
import { FileDragUploadComponent } from 'app/core/file-drag-upload/file-drag-upload.component';
import { ViewReportPageComponent } from './view-report-page/view-report-page.component';
import { CoreModule } from 'app/core/core.module';
import { ValidationCardComponent } from './validation-card/validation-card.component';
import { FruitsServiceService } from '../laas/fruits-land-record/fruits-service.service';
import { FreshAuthService } from './fresh-auth.services';

@NgModule({
  imports: [
    DependenciesModule,
    CommonModule,
    ModalModule.forRoot(),
    FreshAppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    MatDialogModule,
    NgbModule,
    MatDatepickerModule,
    AdminModule,
    MatLegacyTabsModule,
    MatIconModule,
    MatLegacyCardModule,
    MatLegacyMenuModule,
    MatSidenavModule,
    MatLegacySelectModule,
    MatLegacySlideToggleModule,
    MatLegacyProgressBarModule,
    
  ],

  providers: [
    BsModalService, AdminService, FruitsServiceService,FreshAuthService
  ],
  declarations: [ViewDisbursedComponent, ViewNtbComponent,ViewreviewJourneyComponent, ViewIncompleteJourneyComponent, ViewFailurePageComponent, ViewReportPageComponent, FreshAppComponent, ViewSummaryComponent, ViewEtbComponent,
    OpenDialogYesOrNo,ReconciliationReportsComponent, ErrorLogComponent, ValidationCardComponent ]
})
export class FreshAppModule { }
